import ApprovalHeading from './ApprovalHeading';
import ApprovalStatusDot from './ApprovalStatusDot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalSidebarStatusHeading = () => {
  return /*#__PURE__*/_jsxs("div", {
    className: "display-flex align-center",
    children: [/*#__PURE__*/_jsx(ApprovalStatusDot, {}), /*#__PURE__*/_jsx(ApprovalHeading, {})]
  });
};
export default ApprovalSidebarStatusHeading;